import * as types from '../../lib/actionTypes.es6';

const initialState = {
  loader: false,
  gateway_configs: null,
  get_configs_error: null,

  config_raw_loader: false,
  gateway_config_raw: null,
  get_config_raw_error: null,

  publish_loader: false,
  successfully_published: null,
  publish_error: null,

  create_loader: false,
  successfully_created: null,
  create_error: null,
};

export default function gatewayConfigsReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_GATEWAY_CONFIGS_REQUEST:
      return { ...state, loader: true, get_configs_error: null };
    case types.GET_GATEWAY_CONFIGS_SUCCESS:
      return { ...state, loader: false, gateway_configs: action.payload, get_configs_error: null };
    case types.GET_GATEWAY_CONFIGS_FAIL:
      return { ...state, loader: false, get_configs_error: action.payload };

    case types.GET_GATEWAY_CONFIG_RAW_REQUEST:
      return { ...state, config_raw_loader: true, gateway_config_raw: null, get_config_raw_error: null };
    case types.GET_GATEWAY_CONFIG_RAW_SUCCESS:
      return { ...state, config_raw_loader: false, gateway_config_raw: action.payload, get_config_raw_error: null };
    case types.GET_GATEWAY_CONFIG_RAW_FAIL:
      return { ...state, config_raw_loader: false, get_config_raw_error: action.payload };
    case types.GET_GATEWAY_CONFIG_RAW_RESET:
      return { ...state, gateway_config_raw: null, get_config_raw_error: null };

    case types.PUBLISH_GATEWAY_CONFIG_REQUEST:
      return { ...state, publish_loader: true, successfully_published: null, publish_error: null };
    case types.PUBLISH_GATEWAY_CONFIG_SUCCESS:
      return { ...state, publish_loader: false, successfully_published: action.payload, publish_error: null };
    case types.PUBLISH_GATEWAY_CONFIG_FAIL:
      return { ...state, publish_loader: false, successfully_published: null, publish_error: action.payload };
    case types.PUBLISH_GATEWAY_CONFIG_RESET:
      return { ...state, successfully_published: null, publish_error: null };

    case types.CREATE_GATEWAY_CONFIG_REQUEST:
      return { ...state, create_loader: true, successfully_created: null, create_error: null };
    case types.CREATE_GATEWAY_CONFIG_SUCCESS:
      return { ...state, create_loader: false, successfully_created: action.payload, create_error: null };
    case types.CREATE_GATEWAY_CONFIG_FAIL:
      return { ...state, create_loader: false, successfully_created: null, create_error: action.payload };
    case types.CREATE_GATEWAY_CONFIG_RESET:
      return { ...state, successfully_created: null, create_error: null };

    default:
      return state;
  }
}
